module.exports = "<!-- \r\n<footer >\r\n  <p>Powered by Gravity</p>\r\n</footer> -->"